import type { ReactNode } from 'react';
import { Button } from '../../../shared/ui';

type Props = {
  isLoaded: boolean;
  isSubmitting: boolean;
  loadingText: string;
  children: ReactNode;
  className?: string;
};

export function AuthSubmitButton({ isLoaded, isSubmitting, loadingText, children, className = '' }: Props) {
  return (
    <Button
      type="submit"
      variant="marketing-primary"
      disabled={!isLoaded || isSubmitting}
      loading={isSubmitting}
      loadingText={loadingText}
      className={`w-full !rounded-full !px-6 !py-4 !text-[17px] !font-semibold hover:scale-[1.02] hover:shadow-[0_10px_30px_rgba(245,165,36,0.35)] ${className}`}
    >
      {children}
    </Button>
  );
}
